var _rect, _rect2, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAchievement = function SvgAchievement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 22,
    x: 4,
    y: 43,
    fill: "#6C9BF1",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 32,
    x: 26,
    y: 33,
    fill: "#2F68D1",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 12,
    x: 48,
    y: 53,
    fill: "#B4CFFF",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    d: "M34.549 2.927c.3-.921 1.603-.921 1.902 0l2.529 7.783a1 1 0 0 0 .951.691h8.184c.968 0 1.371 1.24.587 1.81l-6.62 4.81a1 1 0 0 0-.364 1.117l2.53 7.784c.299.921-.756 1.687-1.54 1.118l-6.62-4.81a1 1 0 0 0-1.176 0l-6.62 4.81c-.784.57-1.839-.197-1.54-1.118l2.53-7.783a1 1 0 0 0-.364-1.119l-6.62-4.81c-.784-.57-.381-1.809.587-1.809h8.184a1 1 0 0 0 .951-.69z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD2A8",
    d: "M13.5 34c-.202-2.167-.398-3.253-.985-3.905-.587-.653-1.565-.87-3.515-1.095 1.95-.224 2.928-.442 3.515-1.095.587-.652.783-1.738.985-3.905.202 2.167.398 3.253.985 3.905.587.653 1.564.87 3.515 1.095-1.95.224-2.927.442-3.515 1.095-.587.652-.783 1.738-.985 3.905M57.5 26c-.292-2.817-.575-4.229-1.423-5.077S53.817 19.792 51 19.5c2.817-.292 4.229-.575 5.077-1.423S57.208 15.817 57.5 13c.292 2.817.575 4.229 1.423 5.077S61.183 19.208 64 19.5c-2.817.292-4.229.575-5.077 1.423S57.792 23.183 57.5 26M12.5 15c-.292-2.6-.575-3.903-1.423-4.687C10.229 9.53 8.817 9.27 6 9c2.817-.27 4.229-.53 5.077-1.314.848-.782 1.131-2.085 1.423-4.686.292 2.6.575 3.903 1.423 4.686C14.771 8.47 16.183 8.731 19 9c-2.817.27-4.229.53-5.077 1.313S12.792 12.4 12.5 15"
  })));
};
export default SvgAchievement;